import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import {
  setSelectionWindowView,
} from "../../actions/actionFunctions";
import SelectionViewSwitchers from './selectionViewSwitchers';

import Analytics from './../../analytics';

import BacksplashSelect from './backsplashSelect';
import FiltersButton from './filtersButton';
import CountertopSwitchers from "../kvComponent/navigation/countertopSwitchers";
import CabinetSwitchers from "../kvComponent/navigation/cabinetSwitchers";
import ActionTypes from "../../misc/actionTypes";
import ShareButton from "../common/shareButton";
import BodyPanelRadio from "../visComponents/navigation/desktop/bodyPanelRadio";
import {CABINET_GROUP, COUNTERTOP_GROUP} from "../kvComponent/core/constants";
import LanguageSwitcher from "../common/languageSwitcher";
import ShoppingCartButton from "../ui/shoppingCartButton";
import {COUNTERTOP_GROUP_BATHROOM} from "../bvSceneComponent/core/constants";
import LookAllWallsRadioButton from "../look/lookNavigation/lookMain/lookAllWallsRadioButton";
import {getCurrentLayout} from "../appLayout";
import {getCommonVisualizerType} from "../../config";


class SelectionMainHeader extends Component {

  static propTypes = {
    activeSubPart: PropTypes.object,
    searchText: PropTypes.string.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
  };

  handleChangeListView = (e) => {
    Analytics.sendClickEvent("change-list-view-" + e.target.dataset.view);
    this.props.handleChangeListView(+e.target.dataset.view);
  };

  backsplashSelectClick = () => {
    $(window).trigger('resize');
    $(window).trigger(ActionTypes.UPDATE_QUOTING_TOOL);
  };

  render() {
    const {activeSubPart, fabricatorData, isMobile} = this.props;
    const layout = getCurrentLayout();
    const fabricatorSettings = fabricatorData.settings;

    let subPartPartId = '';
    if (activeSubPart) {
      subPartPartId = activeSubPart.part.partId;
    }

    const isCabinet = CABINET_GROUP.includes(subPartPartId);

    const isCountertop = COUNTERTOP_GROUP.includes(subPartPartId) ||
      ((document.kvConfig.visualizerType === "bvScene" || document.kvConfig.visualizerType === "Bathroom")
        && COUNTERTOP_GROUP_BATHROOM.includes(subPartPartId));

    const showBacksplashSelect = subPartPartId === "backsplash" && (getCommonVisualizerType() === "kitchen");

    const showDisabledRadioButtons = activeSubPart && activeSubPart.part.canBeDisabled;

    return (
      <div className="bv-item-header">
        {!fabricatorData.isCaesarStone && (showBacksplashSelect || isCabinet || isCountertop || showDisabledRadioButtons) ? (
          <div className="bv-item-header__left">
            {showDisabledRadioButtons && activeSubPart ? <BodyPanelRadio isMobile={isMobile} activeSubPart={activeSubPart.part} quotingTool={true}/> : null}
            {showBacksplashSelect ? <BacksplashSelect updateParent={this.backsplashSelectClick}/> : null}
            {(isCabinet || isCountertop) && activeSubPart ? (
              <div className="bv-item-header__select">
                {isCabinet
                  ? layout.isNewLayout
                    ? <LookAllWallsRadioButton lookFeature={activeSubPart.part.activeFeature}/>
                    : <CabinetSwitchers showAsDropdown={true} isMaterials={true} activeSubPart={activeSubPart.part}/>
                  : null}
                {isCountertop
                  ? layout.isNewLayout
                    ? <LookAllWallsRadioButton lookFeature={activeSubPart.part.activeFeature}/>
                    : <CountertopSwitchers showAsDropdown={true} isMaterials={true} activeSubPart={activeSubPart.part}/>
                  : null}
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="bv-item-header__right">
          {subPartPartId === "backsplash" && isMobile
            ? null
            : <SelectionViewSwitchers handleChangeListView={this.handleChangeListView} activeSubPart={activeSubPart} />}
          <div className="bv-item-header__search">
            <FormattedMessage id="quotingTool.main.searchPlaceholder" defaultMessage="search">
              {(placeholder) => (
                <input className={"bv-item-header__search-input" + (this.props.searchText ? " search-input--no-icon" : "")}
                       value={this.props.searchText} type="text"
                       onChange={this.props.handleSearchInputChange} placeholder={placeholder}/>
              )}
            </FormattedMessage>
            {this.props.searchText ? (
              <button className="bv-item-header__search-reset" onClick={() => {
                this.props.handleSearchInputChange({target:{value:""}})
              }}/>
            ) : null}
          </div>
          <div className="bv-item-header__buttons">
            {isMobile && fabricatorSettings.enableSharing ? <ShareButton renderList={true}/> : null}
            {isMobile ? <LanguageSwitcher/> : null}
            {fabricatorData.isCaesarStone ? null : <FiltersButton/>}
            <ShoppingCartButton/>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {selectionWindowView, selectionFeatureInfo, activeFeature} = store.selectionState;
  const {isMobile} = store.serverState;
  return {
    selectionWindowView,
    selectionFeatureInfo,
    isMobile,
    fabricatorData: store.fabricatorState,
    activeFeature, // to update active feature
  };
};

const mapDispatchToProps = {
  handleChangeListView: setSelectionWindowView,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainHeader);
